import React from "react"
import styled from "styled-components"

const SameRatioContainer = ({
  children,
  className = "random",
  ratio = 1,
  width = `100%`,
}) => {
  return (
    <Container width={width} className={className}>
      <Wrap ratio={ratio}>
        <Content>{children}</Content>
      </Wrap>
    </Container>
  )
}

const Container = styled.div`
  width: ${props => props.width};
  background-color: transparent;
  overflow: hidden;
`
const Wrap = styled.div`
  margin: 0 auto;
  width: 100%;
  padding-bottom: ${props => props.ratio * 100}%;
  position: relative;
  overflow: hidden;
`
const Content = styled.div`
  color: white;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`
export default SameRatioContainer
